// extracted by mini-css-extract-plugin
var _1 = "GroupCard_background__cd53c";
var _2 = "GroupCard_destItem__1daf2";
var _3 = "GroupCard_droppableContainer__7d6d6";
var _4 = "GroupCard_droppedItem__b8533";
var _5 = "GroupCard_groupWrapper__92fca";
var _6 = "GroupCard_label__3f4f3";
var _7 = "GroupCard_mask__08957";
var _8 = "GroupCard_placeholder__63636";
var _9 = "GroupCard_stackContainer__7113d";
export { _1 as "background", _2 as "destItem", _3 as "droppableContainer", _4 as "droppedItem", _5 as "groupWrapper", _6 as "label", _7 as "mask", _8 as "placeholder", _9 as "stackContainer" }
